import React from 'react';
import Terms from '../Terms/Terms';

export default function Privacy() {
  return <Terms />;
}
